interface DiagonalLinesProps {
  variant?: "gold" | "dark";
  intensity?: "light" | "medium" | "bold";
  className?: string;
}

export default function DiagonalLines({
  variant = "gold",
  intensity = "medium",
  className = "",
}: DiagonalLinesProps) {
  const baseColor = variant === "gold" ? "11,31,63" : "0,0,0";
  const opacityMap = {
    light: 0.04,
    medium: 0.1,
    bold: 0.2,
  };
  const baseOpacity = opacityMap[intensity] ?? 0.1;

  const lines = [
    { top: "0%", left: "-10%", width: "65%", angle: 16, opacity: baseOpacity, height: 2 },
    { top: "35%", right: "-12%", width: "75%", angle: -12, opacity: baseOpacity * 0.85, height: 2 },
    { top: "68%", left: "5%", width: "55%", angle: 20, opacity: baseOpacity * 0.7, height: 2 },
    { top: "88%", right: "-5%", width: "50%", angle: -18, opacity: baseOpacity * 0.6, height: 1 },
    { top: "18%", right: "20%", width: "35%", angle: 24, opacity: baseOpacity * 0.5, height: 1 },
  ];

  return (
    <div className={`absolute inset-0 pointer-events-none overflow-hidden z-0 ${className}`}>
      {lines.map((line, i) => (
        <div
          key={i}
          className="absolute hidden lg:block"
          style={{
            top: line.top,
            left: line.left,
            right: line.right,
            width: line.width,
            height: `${line.height}px`,
            background: `rgba(${baseColor},${line.opacity})`,
            transform: `rotate(${line.angle}deg)`,
            transformOrigin: line.left ? "left center" : "right center",
          }}
        />
      ))}
    </div>
  );
}
